import { Injectable, inject } from '@angular/core';
import { type Params } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map, mergeMap, withLatestFrom } from 'rxjs/operators';

import { isUuid } from '@common/helpers';

import { SettingsHttpService } from '@web/store/website/settings/settings.http.service';

import { RouterFacade } from '@web/store/router/router.facade';

import AppActions from '@web/store/app/app.actions';
import SettingsActions from './settings.actions';

@Injectable()
export class SettingsEffects {
    private readonly actions$ = inject(Actions);
    private readonly routerFacade = inject(RouterFacade);
    private readonly settingsHttpService = inject(SettingsHttpService);

    public readonly loadSiteSettings$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AppActions.initAppSuccess),
            withLatestFrom(this.routerFacade.routerParams$, (_, routerParams: Params) => ({
                routerParams,
            })),
            filter(({ routerParams }) => routerParams.siteId && !isUuid(routerParams.siteId)),
            mergeMap(({ routerParams }) => {
                return this.settingsHttpService.getSiteSettings(routerParams.siteId);
            }),
            map((settings) => {
                return SettingsActions.loadSiteSettingsSuccess({ settings });
            })
        )
    );
}
